﻿$.fn.dxCtrlBcRadioLienAppli = function custom_dxCtrlRadioBcLienAppli(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlbcradiolienappli dx-ctrl");
        this.createInstance(new cdxCtrlBcRadioLienAppli(this, option));
    }
    return this;
}

window.cdxCtrlBcRadioLienAppli = function (container, option) {
    var Me = this

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    function mConstruit() {
        container.empty();
        var $Table = $("<table/>").appendTo(container)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td/>").appendTo($Tr)
        var opt = {
            dataSource: gestCognoss.dsAppli,
            layout: "horizontal",
            value: option.value,
            itemTemplate: function (itemData, itemIndex, itemElement) {
                //if (typeof itemData.bcAppli == "undefined") {
                    $("<div>" + itemData.nom + "</div>").appendTo(itemElement)
                //} else {
                //    $A = $("<a href='javascript:void(0)'>" + itemData.nom + "</a>").appendTo(itemElement)
                //    $A.on("click", function (e) {
                //        $("<div/>").appendTo("body").dxCtrlBcEntetePiedAppli({
                //            bddCtrl: option.bddCtrl,
                //            data: itemData.bcAppli
                //        })
                //    })
                //}
            },
            onValueChanged: function (e) {
                if (typeof option.onValueChanged != 'undefined') option.onValueChanged(e.value)
            }
        }

        var dxLstRadio = $("<div/>").appendTo($Td).dxCtrlRadioGroup(opt).dxCtrlRadioGroup("instance")


        var $Td = $("<td/>").appendTo($Tr)
        $("<div/>").appendTo($Td).dxCtrlButton({
            text: "Exporter",
            onClick: function (e) {
                if (typeof option.onDemandeExport != 'undefined') option.onDemandeExport()
            }
        })
    }

    this.element = function () { return container; }

    mConstruit();
}